import { render, staticRenderFns } from "./ReportTraffic.vue?vue&type=template&id=32670934&"
import script from "./ReportTraffic.vue?vue&type=script&lang=js&"
export * from "./ReportTraffic.vue?vue&type=script&lang=js&"
import style0 from "./ReportTraffic.vue?vue&type=style&index=0&id=32670934&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports